import React, { useContext, useEffect, useState } from 'react';
import format from 'date-fns/format'
import {
  useNavigate, useParams, useSearchParams,
} from 'react-router-dom'
import { useInView } from 'react-intersection-observer'
import StreamContext from 'utils/StreamContext'
import { ReactComponent as IconArrowRight } from 'images/arrow-right.svg';
import usePlaylist from 'sdk/hooks/usePlaylist';
import { getFeedGroup } from 'sdk/utils/feed';
import Page from 'modules/app/components/Page';
import PostView from 'components/shared/PostView';
import { DateInput } from 'components/shared/Input';
// import Button from 'components/shared/Button';
import useFeedPosts from 'sdk/hooks/feed/useFeedPosts';
import CategoriesFilter from 'components/shared/CategoriesFilter';
import PageContainer from 'components/shared/PageContainer';
import Skeleton from 'components/shared/Skeleton';
import NoContent from 'components/shared/NoContent/NoContent';
import styles from './PlaylistMostLiked.module.scss';

function PlaylistMostLiked() {
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const asset = searchParams.get('asset')
  const playlistData = usePlaylist(6 || '')
  const isDaily = Boolean(playlistData?.data?.is_date_enabled)
  const [activeCategory, setActiveCategory] = useState<string | null>(null)
  const { client } = useContext(StreamContext)
  const [, setFeed] = useState<any>()
  const feedName = 'global_flat'
  const { ref, inView } = useInView()
  const [day, setDay] = useState<Date | null>(new Date())
  const [posts, setPosts] = useState<any>([])
  const [activePostId, setActivePostId] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    if (client) {
      const filters: string[] = []
      if (activeCategory) {
        filters.push(`cat-${activeCategory}`)
      }
      if (asset) {
        filters.push(`asset-${asset}`)
      }
      if (id) {
        filters.push(`playlist-${id}`)
      }
      if (isDaily) {
        filters.push(`date-${format(day || (new Date()), 'yyyy-MM-dd')}`)
      }
      setFeed(client.feed(feedName, getFeedGroup(filters)))
    }
  }, [client, activeCategory, day])

  const feedData = useFeedPosts({ name: 'global_flat', id: activeCategory ? `cat-${activeCategory}` : 'global' }, '', 'most_recent', 6)

  useEffect(() => {
    if (feedData.isSuccess) {
      setPosts(feedData?.data?.pages.map((v) => v?.results).flat() || [])
    }
  }, [feedData.isSuccess])

  useEffect(() => {
    if (inView && feedData.hasNextPage) {
      feedData.fetchNextPage()
    }
  }, [inView, feedData.hasNextPage])

  return (
    <PageContainer className={styles.container}>
      <div className={styles.headerRow}>
        <div className={styles.h} onClick={() => navigate(-1)}>
          <h1 className={styles.title}>
            <IconArrowRight />
            Most Liked
          </h1>
        </div>
        <CategoriesFilter
          value={activeCategory}
          onChange={setActiveCategory}
        />
        {isDaily ? (
          <DateInput
            className={styles.dayInput}
            value={day}
            onChange={(value: Date | null) => {
              setDay(value)
            }}
            dateFormat="MMM, dd"
          />
        ) : null}
      </div>
      {!feedData.isLoading ? (
        <div className={styles.playlistPosts}>
          {posts.map((post: any) => (
            <div
              className={styles.playlistItem}
              key={post?.id}
              onMouseEnter={() => setActivePostId(post?.id)}
              onMouseLeave={() => setActivePostId('')}
            >
              <PostView
                feedId="global"
                feedName="global_flat"
                data={post}
                isDaily={isDaily}
                isActive={post?.id === activePostId}
              />
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.playlistPosts}>
          {Array.from(Array(12).keys()).map((item: number) => (
            <div className={styles.playlistItem} key={item}>
              <Skeleton className={styles.playlistItemSkeleton} />
            </div>
          ))}
        </div>
      )}
      <div ref={ref} />
      {!posts?.length && (
        <div className={feedData.isLoading ? styles.playlistPosts_loading : ''}>
          <NoContent
            message="No data satisfying the filters"
          />
        </div>
      )}
    </PageContainer>
  )
}

function PlaylistPage() {
  return (
    <Page activeLink="/">
      <PlaylistMostLiked />
    </Page>
  )
}

export default PlaylistPage
